import { Box, ScrollView } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken, primitive } from 'styles/constants';

/**
 * A wrapper for `ListItem` components.
 *
 * A list is built from its building blocks. See Storybook for example.
 */
export const List = ScrollView.withConfig(props => ({
  marginBottom: '4',
  ...props,
}));

/**
 * Displays a styled list item with borders and padding.
 */
export const ListItem = Box.withConfig<{ activeHighlight?: boolean; isFirstChild?: boolean }>(
  ({ activeHighlight, isFirstChild }) => ({
    borderBottomWidth: '1px',
    borderColor: primitive.$greyFour,
    ...(activeHighlight && { backgroundColor: getDesignToken('background-default') }),

    ...(isFirstChild && {
      borderTopWidth: '1px',
    }),
  })
);

/**
 * Content spacing for a List item.
 *
 * This component exists if the entire contend needs to
 * be replaced for customization.
 */
export const ListItemContent = Box.withConfig({
  paddingY: '16px',
  paddingX: '96px',
});

/**
 * Styled title for ListItem content
 */
export const ListItemTitle = withTypography({
  fontFamily: 'heading',
  fontSize: 'md',
  color: primitive.$bbqBrown,
  bold: true,
  style: { width: '100%' },
});

/**
 * Styled subtext for a ListItem's content
 */
export const ListItemSubtext = withTypography({ variant: 'copyTwo', color: primitive.$bbqBrown });
